export const storeReportDefaultGridState = {
    "sideBar": {
        "visible": true,
        "position": "right",
        "openToolPanel": null,
        "toolPanels": {
            "columns": {
                "expandedGroupIds": []
            },
            "filters": {
                "expandedGroupIds": [],
                "expandedColIds": []
            }
        }
    },
    "columnVisibility": {
        "hiddenColIds": ["trip_number", "outbound_scan_date", "time_zone_id"]
    },
    "columnSizing": {
        "columnSizingModel": [
            {
                "colId": "alternate_reference",
                "width": 150
            },
            {
                "colId": "load_start",
                "width": 150
            },
            {
                "colId": "appointment_date",
                "width": 175
            },
            {
                "colId": "appointment_window",
                "width": 150
            },
            {
                "colId": "load_end",
                "width": 175
            },
            {
                "colId": "delivery_date",
                "width": 175
            },
            {
                "colId": "local_time",
                "width": 150
            },
            {
                "colId": "delivery_status",
                "width": 200
            },
            {
                "colId": "external_bill_of_lading",
                "width": 150
            },
            {
                "colId": "store_number",
                "width": 150
            },
            {
                "colId": "asn_number",
                "width": 150
            },
            {
                "colId": "trip_number",
                "width": 150
            },
            {
                "colId": "week_no",
                "width": 110
            },
            {
                "colId": "total_cartons",
                "width": 150
            },
            {
                "colId": "consignee_region",
                "width": 100
            },
            {
                "colId": "load_end_hours",
                "width": 150
            },
            {
                "colId": "delivery_day",
                "width": 150
            },
            {
                "colId": "first_delivered_scan",
                "width": 200
            },
            {
                "colId": "last_delivered_scan",
                "width": 200
            }
        ]
    },
    "columnOrder": {
        "orderedColIds": [
            "alternate_reference",
            "load_start",
            "appointment_date",
            "appointment_window",
            "load_end",
            "delivery_date",
            "local_time",
            "delivery_status",
            "external_bill_of_lading",
            "store_number",
            "asn_number",
            "trip_number",
            "week_no",
            "total_cartons",
            "consignee_region",
            "load_end_hours",
            "delivery_day",
            "first_delivered_scan",
            "last_delivered_scan"
        ]
    },
}